import { LinkSlackChannel } from '../../../domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemoteLinkSlackChannel extends BaseHttpService<LinkSlackChannel.Model> implements LinkSlackChannel {
  async linkSlackChannel(body: LinkSlackChannel.Params): Promise<LinkSlackChannel.Model> {
    return await this.request('post', body);
  }
}
